import rules from "../Data/Rules"
import functions from "../Data/Functions"

export default {
    init: async (Parameters) => {
        Parameters.AboriginalStatus = await functions.GetCodeBy({ Type: "Aboriginal Status" })
        Parameters.BNZ_Associations = await functions.GetCodeBy({ Type: "Associations", Organisation: 500 })
        Parameters.BNZ_Teams = await functions.GetCodeBy({ Type: "Teams", Region: 3475 })
        Parameters.Sizes = await functions.GetCodeBy({ Type: "Sizes" })
        Parameters.Countries = await functions.GetCountries()
        return LoadModel(Parameters)
    },

    save: async (results) => {
        // let Contacts = {}
        let ContactDetails = []
        let files = []
        results.steps.forEach((step) => {
            // console.log(step.Model)
            let id = 0, Doc_id = 0, value = ''
            for (const property in step.Model) {
                // Reset the variables
                id = 0, Doc_id = 0, value = ''
                for (const item in step.Schema[property]) {
                    // console.log(item)
                    // if (item == 'id') { id = Number(step.Schema[property][item]) }
                    // if (item == 'Docid') { Doc_id = Number(step.Schema[property][item]) }
                    // if (item == 'type' && step.Schema[property][item] == 'file') { file = true }

                    // console.log(item, step.Schema[property][item])
                    switch (item) {
                        case 'id':
                            id = Number(step.Schema[property][item])
                            break;
                        case 'Doc_id':
                            Doc_id = Number(step.Schema[property][item])
                            break
                        case 'Doc_Label':
                            Doc_Label = step.Schema[property][item]
                            break
                        case 'teams':
                            Teamlist = step.Model[property]
                            break
                        default:

                            break;
                    }
                }
                // field = property
                value = step.Model[property]
                // console.log(`${property}: ${step.Model[property]}`);
                if (id > 0) {
                    // console.log(id, field, value);
                    ContactDetails.push({ Type: id, Description: value })
                }
                if (Doc_id > 0) {
                    files.push({ Type: Doc_id, File: value })
                }
            }
        })

        let payload = {
            Portal_Data: results,
            Contact: {
                firstname: results.steps[0].Model.firstname,
                surname: results.steps[0].Model.surname,
                email: results.steps[0].Model.email,
                mobile: results.steps[0].Model.mobile,
                gender: functions.getDBGender(results.steps[0].Model.gender),
                date_of_birth: results.steps[0].Model.DOB,
                password: results.steps[0].Model.password,
                photo: functions.formDataFile(results.steps[0].Model.photo),
                team: 310,
                role: 3
            },
            Contact_Details: ContactDetails,
            Files: files
        }
        // functions.LoadData(payload);
        console.log(payload)
        console.log(results)
    }
}

const LoadModel = (Passed) => {
    let result = {}
    switch (Passed.Type) {
        // Player Form
        case 'Player':
            result = {
                Portal: '2022 BNZ Player',
                MainColor: "#151922",
                Logo: require('../assets/BNZ.jpeg'),
                Title: `<h2>Basketball New Zealand Registration Form</h2>`,
                Description: ``,
                steps: [
                    {
                        stepno: 1,
                        title: 'Association/Team Selection',
                        valid: true,
                        information: ``,
                        Model: {},
                        Schema: {
                            Association: {
                                type: 'select',
                                label: 'Select the Association you want to register for',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Product is Required')],
                                class: 'mx-1 px-1',
                                items: Passed.BNZ_Associations,
                            },
                            Team: {
                                type: 'select',
                                label: 'Select the Team you want to register for',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Team is Required')],
                                class: 'mx-1 px-1',
                                items: Passed.BNZ_Teams
                            }
                        },
                    },
                    // Step 2
                    {
                        stepno: 2,
                        title: 'Personal Details',
                        valid: true,
                        information: '',
                        Model: {},
                        Schema: {
                            firstname: {
                                type: 'text',
                                label: 'First Name',
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'person',
                                rules: [rules.requiredMsg('Firstname is Required')],
                                class: 'mx-1 px-1',
                                tooltip: {
                                    color: 'blue', label: 'Enter your Firstname here'
                                }
                            },
                            surname: {
                                type: 'text',
                                label: 'Last Name',
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'person',
                                rules: [rules.requiredMsg('Surname is Required')],
                                class: 'mx-1 px-1'
                            },
                            gender: {
                                type: "select",
                                label: "Assigned Gender at Birth",
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Gender is Required')],
                                class: 'mx-1 px-1',
                                items: rules.Gender,
                            },
                            DOB: {
                                type: 'text',
                                ext: 'date',
                                locale: 'en',
                                prependIcon: 'event',
                                label: 'Date of Birth',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Date of Birth is Required')],
                                class: 'mx-1 px-1'
                            },
                            email: {
                                type: 'email',
                                label: 'Email Address',
                                outlined: true,
                                dense: true,
                                rules: [rules.validEmail, rules.requiredMsg('Email is Required')],
                                prependInnerIcon: 'alternate_email',
                                class: 'mx-1 px-1'
                            },
                            mobile: {
                                type: 'tel',
                                label: 'Phone Number',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Phone Number is Required')],
                                mask: "####-###-###",
                                prependInnerIcon: 'phone',
                                mask: "####-###-###",
                                class: 'mx-1 px-1'
                            },
                            Country: {
                                type: 'select',
                                label: 'Country of Birth',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Country of Birth is Required')],
                                class: 'mx-1 px-1',
                                items: Passed.Countries
                            }
                        },
                    },
                    // Step 3
                    {
                        stepno: 3,
                        title: 'Other Information',
                        valid: true,
                        information: '',
                        Model: {},
                        Schema: {
                            Height: {
                                id: "353",
                                type: 'number',
                                label: 'Height (cms)',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Height is Required')],
                                class: 'mx-1 px-1'
                            },
                            Weight: {
                                id: "703",
                                type: 'number',
                                label: 'Weight (kgs)',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Weight is Required')],
                                class: 'mx-1 px-1'
                            },
                            School: {
                                type: 'text',
                                // prependIcon: 'event',
                                label: 'School Attended',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('School is Required')],
                                class: 'mx-1 px-1',
                            },
                            SchoolGradYear: {
                                type: 'text',
                                // prependIcon: 'event',
                                label: 'School Graduation Year',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('School Graduation Year is Required')],
                                class: 'mx-1 px-1',
                            },
                            SingletSize: {
                                type: "select",
                                label: "Singlet Sizes",
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Singlet Size is Required')],
                                class: 'mx-1 px-1',
                                items: Passed.Sizes
                            },
                            ShortsSize: {
                                type: "select",
                                label: "Shorts Size",
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Short Size is Required')],
                                class: 'mx-1 px-1',
                                items: Passed.Sizes
                            },
                            ParentOneName: {
                                type: 'text',
                                label: 'Parent/Guardian 1 Full Name',
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'person',
                                rules: [rules.requiredMsg('Parent/Guardian 1 Full Name is Required')],
                                class: 'mx-1 px-1',
                            },
                            ParentOnePhone: {
                                type: 'tel',
                                label: 'Parent/Guardian 1 Phone',
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'phone',
                                mask: "####-###-###",
                                rules: [rules.requiredMsg('Parent/Guardian 1 Phone Number is Required')],
                                class: 'mx-1 px-1',
                            },
                            ParentOneEmail: {
                                type: 'email',
                                label: 'Parent/Guardian 1 Email',
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'email',
                                rules: [rules.requiredMsg('Parent/Guardian 1 Email is Required')],
                                class: 'mx-1 px-1',
                            },
                            ParentTwoName: {
                                type: 'text',
                                label: 'Parent/Guardian 2 Full Name',
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'person',
                                rules: [rules.requiredMsg('Parent/Guardian 2 Full Name is Required')],
                                class: 'mx-1 px-1',
                            },
                            ParentTwoPhone: {
                                type: 'tel',
                                label: 'Parent/Guardian 2 Phone Number',
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'phone',
                                mask: "####-###-###",
                                rules: [rules.requiredMsg('Parent/Guardian 2 Phone Number is Required')],
                                class: 'mx-1 px-1',
                            },
                            ParentTwoEmail: {
                                type: 'email',
                                label: 'Parent/Guardian 2 Email',
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'email',
                                rules: [rules.requiredMsg('Parent/Guardian 2 Email is Required')],
                                class: 'mx-1 px-1',
                            },
                            CovidStatus: {
                                type: "select",
                                label: "COVID Status",
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('COVID Status is Required')],
                                class: 'mx-1 px-1',
                                items: [
                                    "Not Vaccinated",
                                    "First Vaccination",
                                    "Second Vaccination",
                                ]
                            },
                            VaccPassExp: {
                                type: 'text',
                                ext: 'date',
                                locale: 'en',
                                // prependIcon: 'event',
                                label: "My Vaccine Pass Expiry Date",
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('My Vaccine Pass Expiry Date is Required')],
                                class: 'mx-1 px-1',
                            }
                        },
                    },
                    // Step 4
                    {
                        stepno: 4,
                        title: 'Finalisation',
                        valid: true,
                        information: `Thank you for your submitted registration for the 2022 NBL1 season.</br>
                        Please note this submitted registration is <b>PENDING APPROVAL</b> from the league and will be reviewed.<br></br>
                        You and your association delegate will receive an email notification once this has been approved by the league.<br></br>
                        <hr><br></br>
                        Please stay up to date with all NBL1 news and information throughout the season on the <a href="https://nbl1.com.au/" target="blank">NBL1 website</a><br></br>`,
                        Model: {},
                        Schema: {}
                    }
                ]
            }
            break;

        default:

            break;
    }
    return result;
}

/*
// Save BNZ Data
export const BNZ_Save = async (results) => {
    // let Contacts = {}
    let ContactDetails = []
    let files = []
    results.steps.forEach((step) => {
        // console.log(step.Model)
        let id = 0, Doc_id = 0, value = ''
        for (const property in step.Model) {
            // Reset the variables
            id = 0, Doc_id = 0, value = ''
            for (const item in step.Schema[property]) {
                // console.log(item)
                // if (item == 'id') { id = Number(step.Schema[property][item]) }
                // if (item == 'Docid') { Doc_id = Number(step.Schema[property][item]) }
                // if (item == 'type' && step.Schema[property][item] == 'file') { file = true }

                // console.log(item, step.Schema[property][item])
                switch (item) {
                    case 'id':
                        id = Number(step.Schema[property][item])
                        break;
                    case 'Doc_id':
                        Doc_id = Number(step.Schema[property][item])
                        break
                    case 'Doc_Label':
                        Doc_Label = step.Schema[property][item]
                        break
                    case 'teams':
                        Teamlist = step.Model[property]
                        break
                    default:

                        break;
                }
            }
            // field = property
            value = step.Model[property]
            // console.log(`${property}: ${step.Model[property]}`);
            if (id > 0) {
                // console.log(id, field, value);
                ContactDetails.push({ Type: id, Description: value })
            }
            if (Doc_id > 0) {
                files.push({ Type: Doc_id, File: value })
            }
        }
    })

    let payload = {
        Portal_Data: results,
        Contact: {
            firstname: results.steps[0].Model.firstname,
            surname: results.steps[0].Model.surname,
            email: results.steps[0].Model.email,
            mobile: results.steps[0].Model.mobile,
            gender: functions.getDBGender(results.steps[0].Model.gender),
            date_of_birth: results.steps[0].Model.DOB,
            password: results.steps[0].Model.password,
            photo: functions.formDataFile(results.steps[0].Model.photo),
            team: 310,
            role: 3
        },
        Contact_Details: ContactDetails,
        Files: files
    }
    // functions.LoadData(payload);
    console.log(payload)
    console.log(results)
}
*/